import {watch} from 'vue'
import {createGtm, useGtm} from '@gtm-support/vue-gtm'
import {useCompanyStore} from '../../stores/company'
import {useGlobalStore} from '../../stores/global'
import {useUserStore} from '../../stores/user'

// Employees are only known once the user is loaded, which is after GTM's initial events (gtm.js, gtm.dom, ...).
// So remember them in a cookie after their first login and expose it to GTM before the container loads.
const INTERNAL_USER_COOKIE = 'internal_user'

function rememberEmployee(pinia) {
  watch(
    () => useUserStore(pinia).isEmployee,
    (isEmployee) => {
      if (isEmployee) {
        document.cookie = `${INTERNAL_USER_COOKIE}=true; max-age=31536000; path=/; SameSite=Lax; Secure`
      }
    },
    {immediate: true}
  )
}

function pushInitialUserType() {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    user_type: document.cookie.split('; ').includes(`${INTERNAL_USER_COOKIE}=true`) ? 'employee' : 'customer',
  })
}

// Pushed manually (instead of via the vue-gtm router integration, which skips unnamed routes).
// Routes can exclude stores from initialization in router.beforeEach (e.g. static pages, /authorize),
// so only push once all three stores are actually loaded.
function trackPageviews(router) {
  router.afterEach((to, _from, failure) => {
    let userStore = useUserStore()
    let companyStore = useCompanyStore()
    let globalStore = useGlobalStore()
    if (failure || !globalStore.initialized || !userStore.initialized || !companyStore.initialized) return

    useGtm()?.trackEvent({
      event: 'pageview',
      page_path: to.fullPath,
      userId: userStore.id,
      firstname: userStore.properties.firstname,
      lastname: userStore.properties.lastname,
      email: userStore.email,
      user_type: userStore.isEmployee ? 'employee' : 'customer',
      companyId: companyStore.id,
      companyName: companyStore.name,
      isAdmin: globalStore.hasAuthority('ADMIN'),
    })
  })
}

export function setupGtm(app, router, pinia) {
  const enabled = location.host.startsWith('app')

  rememberEmployee(pinia)

  // Must happen before createGtm is installed, so the value is in the dataLayer when the container loads.
  if (enabled) {
    pushInitialUserType()
  }

  app.use(
    createGtm({
      id: 'GTM-PJZPGBR9',
      enabled,
    })
  )
  trackPageviews(router)
}
